import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';
import Text from '@rsos/components/capstone/base/Text';

export const TimeBox = styled(Box).attrs(({ isCopied }) => ({
  p: 10,
  bg: isCopied ? 'highlights' : 'inherit',
}))``;

export const TimeBoxText = styled(Text).attrs({
  pb: 10,
  fontWeight: 'bold',
  color: 'primaryText',
})``;

export const TimeAgoText = styled(Text).attrs({
  color: 'primaryBase',
  fontWeight: 'bold',
})``;
